import React, { useState } from 'react';
import './MainAppSidebar.css';

const MainAppSidebar = ({ 
  isMobileOpen, 
  onMobileClose,
  isAgentLoggedIn,
  isEmployeeLoggedIn,
  employeeUser,
  activeSection = 'products',
  onNavigateToSection,
  onNavigateToAgentDashboard,
  onAgentLogout,
  onEmployeeLogout
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      id: 'home',
      label: 'Home',
      icon: '🏠',
      description: 'Main Dashboard',
      show: true
    },
    {
      id: 'products',
      label: 'Products',
      icon: '🛡️',
      description: 'Insurance Products',
      show: !isEmployeeLoggedIn  // Hide products for employees
    },
    {
      id: 'extend-policy',
      label: 'Buy/Extend Policy',
      icon: '🔁',
      description: 'Buy or extend policy',
      show: true
    },
    {
      id: 'support',
      label: 'Support',
      icon: '💬',
      description: 'Get Help',
      show: true,
      action: () => window.open('https://wa.me/254738669931?text=hello', '_blank')
    },
    {
      id: 'quote',
      label: 'Generate Quote',
      icon: '📋',
      description: 'Get a Quote',
      show: true,
      action: () => window.open('http://quotations.monarchinsurance.co.ke/', '_blank')
    }
  ];

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
    } else if (onNavigateToSection && item.id) {
      onNavigateToSection(item.id);
    }
    if (onMobileClose) {
      onMobileClose();
    }
  };

  return (
    <aside className={`main-app-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">🛡️</div>
          {!isCollapsed && (
            <div className="logo-text">
              <h2>The Monarch</h2>
              <span>Insurance</span>
            </div>
          )}
        </div>
        
        <button 
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
        
        {/* Mobile Close Button */}
        <button 
          className="mobile-close-btn"
          onClick={onMobileClose}
          title="Close menu"
          aria-label="Close menu"
        >
          ✕
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            item.show && (
              <li key={item.id} className="nav-item">
                <button
                  className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => handleItemClick(item)}
                  title={isCollapsed ? item.label : ''}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {!isCollapsed && (
                    <div className="nav-content">
                      <span className="nav-label">{item.label}</span>
                      <span className="nav-description">{item.description}</span>
                    </div>
                  )}
                </button>
              </li>
            )
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        {/* Agent/Employee Info Section */}
        {(isAgentLoggedIn || isEmployeeLoggedIn) && (
          <div className="user-section">
            <div className="user-avatar">
              {isEmployeeLoggedIn && employeeUser 
                ? (employeeUser.full_name || employeeUser.username || 'E').charAt(0).toUpperCase()
                : 'A'}
            </div>
            {!isCollapsed && (
              <div className="user-info">
                <span className="user-name">
                  {isEmployeeLoggedIn && employeeUser 
                    ? (employeeUser.full_name || employeeUser.username || 'Employee')
                    : 'Agent'}
                </span>
                <span className="user-role">
                  {isEmployeeLoggedIn ? 'Employee' : 'Agent'}
                </span>
              </div>
            )}
          </div>
        )}
        
        <div className="footer-actions">
          {isAgentLoggedIn && !isEmployeeLoggedIn && (
            <>
              <button 
                className="dashboard-btn"
                onClick={() => {
                  onNavigateToAgentDashboard();
                  if (onMobileClose) onMobileClose();
                }}
                title={isCollapsed ? 'Dashboard' : ''}
              >
                <span className="dashboard-icon">📊</span>
                {!isCollapsed && <span>Dashboard</span>}
              </button>
              <button 
                className="logout-btn"
                onClick={() => {
                  onAgentLogout();
                  if (onMobileClose) onMobileClose();
                }}
                title={isCollapsed ? 'Logout' : ''}
              >
                <span className="logout-icon">🚪</span>
                {!isCollapsed && <span>Logout</span>}
              </button>
            </>
          )}
          
          {isEmployeeLoggedIn && (
            <>
              {employeeUser && (
                <div className="employee-info-display">
                  {!isCollapsed && employeeUser.agency_name && (
                    <span className="agency-name">{employeeUser.agency_name}</span>
                  )}
                </div>
              )}
              <button 
                className="logout-btn"
                onClick={() => {
                  onEmployeeLogout();
                  if (onMobileClose) onMobileClose();
                }}
                title={isCollapsed ? 'Logout' : ''}
              >
                <span className="logout-icon">🚪</span>
                {!isCollapsed && <span>Logout</span>}
              </button>
            </>
          )}
        </div>
      </div>
    </aside>
  );
};

export default MainAppSidebar;
